import { NavLink as RouterLink } from 'react-router';
import { styled } from '@mui/material/styles';
import { Box, Button, AppBar, Toolbar, Container, Select, MenuItem } from '@mui/material';
import useAuth from '../../hooks/useAuth';
import useLocales from '../../hooks/useLocales';
import useOffSetTop from '../../hooks/useOffSetTop';
import Logo from '../../components/Logo';
import { PATH_AUTH, PATH_DASHBOARD } from '../../routes/paths';

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 88;

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  height: APP_BAR_MOBILE,
  transition: theme.transitions.create(['height', 'background-color'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  [theme.breakpoints.up('md')]: {
    height: APP_BAR_DESKTOP
  }
}));

export default function MainNavbar() {
  const isOffset = useOffSetTop(100);
  const { isAuthenticated } = useAuth();
  const { allLang, currentLang, onChangeLang, translate } = useLocales();

  return (
    <AppBar
      color="transparent"
      elevation={0}
      sx={{
        borderBottom: '1px solid',
        borderColor: isOffset ? 'divider' : 'transparent',
        bgcolor: isOffset ? 'rgba(255,255,255,0.9)' : 'transparent',
        backdropFilter: isOffset ? 'blur(12px)' : 'none'
      }}
    >
      <ToolbarStyle
        disableGutters
        sx={{ height: { md: isOffset ? APP_BAR_DESKTOP - 16 : APP_BAR_DESKTOP } }}
      >
        <Container
          maxWidth="lg"
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
        >
          <RouterLink to="/">
            <Logo />
          </RouterLink>

          <Box sx={{ flexGrow: 1 }} />

          <Select
            size="small"
            value={currentLang.value}
            onChange={(e) => onChangeLang(e.target.value)}
            sx={{
              mx: 2,
              minWidth: 100,
              color: 'text.primary',
              '& .MuiSvgIcon-root': { color: 'text.secondary' },
              '& .MuiSelect-select': { py: 0.75, typography: 'subtitle2' },
              '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
              '&:hover .MuiOutlinedInput-notchedOutline': { border: 'none' },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': { border: 'none' },
              '&.Mui-focused': { boxShadow: 'none' }
            }}
          >
            {allLang.map((lang) => (
              <MenuItem key={lang.value} value={lang.value}>
                {lang.label}
              </MenuItem>
            ))}
          </Select>

          {isAuthenticated && (
            <Button
              variant="contained"
              component={RouterLink}
              to={PATH_DASHBOARD.root}
              disableElevation
            >
              {translate('menu.dashboard')}
            </Button>
          )}

          {!isAuthenticated && (
            <Button
              variant="text"
              component={RouterLink}
              to={PATH_AUTH.login}
              sx={{ mr: 1, color: 'text.secondary' }}
            >
              {translate('menu.login')}
            </Button>
          )}

          {!isAuthenticated && (
            <Button
              variant="contained"
              component={RouterLink}
              to={PATH_AUTH.register}
              disableElevation
              sx={{ display: { xs: 'none', md: 'inline-flex' } }}
            >
              {translate('menu.register')}
            </Button>
          )}
        </Container>
      </ToolbarStyle>
    </AppBar>
  );
}
